/* import __COLOCATED_TEMPLATE__ from './bandpass-multiplefeedback-posfbnor2.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();